/**
 * Named light color presets.
 * Pick by feel (LIGHT_COLORS.warmAccent) or by Kelvin temperature when
 * authoring product light rigs.
 */
export const LIGHT_COLORS = {
  /** 9000K — cold key, icy / overcast sky */
  coldKey9000: '#a0c4ff',
  /** 7500K — cold key (current), daylight bluish */
  coldKey7500: '#c8dcff',
  /** 6500K — cool fill, soft sky bounce */
  coolFill: '#dbe8ff',
  /** 6500K — neutral, pure white / ambient */
  neutral: '#ffffff',
  /** 5500K — neutral-warm, midday sun */
  neutralWarm: '#fff4e6',
  /** 4500K — warm fill, morning/late sun */
  warmFill: '#ffe0b2',
  /** 3200K — warm accent (current), tungsten / sunset */
  warmAccent: '#ffb46b',
  /** 2700K — hot rim, golden hour */
  hotRim: '#ff8c42',
  /** 2200K — strong warm rim, low sun / fireplace */
  strongWarmRim: '#ff6a3d',
  /** magenta fill — studio "negative fill" pop */
  magentaFill: '#b39ddb',
  /** rim cold — sci-fi / cool backlight */
  rimCold: '#88c5ff',
  /** 4800K — soft warm bounce, wood/floor reflection */
  softWarmBounce: '#fff1c4',
  /** 7000K — cold ambient, exterior sky dome */
  coldAmbient: '#e8f0ff',
} as const

type LightColorName = keyof typeof LIGHT_COLORS

export interface LightColorPreset {
  hex: string
  name: LightColorName
  label: string
  kelvin: number | null
  description: string
}

export const LIGHT_COLOR_PRESETS: LightColorPreset[] = [
  { hex: '#a0c4ff', name: 'coldKey9000',   label: 'cold key',         kelvin: 9000, description: 'icy / overcast sky' },
  { hex: '#c8dcff', name: 'coldKey7500',   label: 'cold key',         kelvin: 7500, description: 'daylight bluish' },
  { hex: '#dbe8ff', name: 'coolFill',      label: 'cool fill',        kelvin: 6500, description: 'soft sky bounce' },
  { hex: '#ffffff', name: 'neutral',       label: 'neutral',          kelvin: 6500, description: 'pure white, ambient' },
  { hex: '#fff4e6', name: 'neutralWarm',   label: 'neutral-warm',     kelvin: 5500, description: 'midday sun' },
  { hex: '#ffe0b2', name: 'warmFill',      label: 'warm fill',        kelvin: 4500, description: 'morning/late sun' },
  { hex: '#ffb46b', name: 'warmAccent',    label: 'warm accent',      kelvin: 3200, description: 'tungsten / sunset' },
  { hex: '#ff8c42', name: 'hotRim',        label: 'hot rim',          kelvin: 2700, description: 'golden hour' },
  { hex: '#ff6a3d', name: 'strongWarmRim', label: 'strong warm rim',  kelvin: 2200, description: 'low sun / fireplace' },
  { hex: '#b39ddb', name: 'magentaFill',   label: 'magenta fill',     kelvin: null, description: 'studio negative fill pop' },
  { hex: '#88c5ff', name: 'rimCold',       label: 'rim cold',         kelvin: null, description: 'sci-fi / cool backlight' },
  { hex: '#fff1c4', name: 'softWarmBounce',label: 'soft warm bounce', kelvin: 4800, description: 'wood/floor reflection' },
  { hex: '#e8f0ff', name: 'coldAmbient',   label: 'cold ambient',     kelvin: 7000, description: 'exterior sky dome' },
]
